










import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonCustomer extends Vue {
  getRouteEdit() {
    const id = this.$route.params.id;
    return this.$router.push({
      name: "customer-edit",
      params: { id },
      query: { t: "" + new Date().getTime() },
    });
  }
}
